export const listUsageRecords = `
   query listUsageRecords($filter: UsageRecordsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listUsageRecords(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
                id
                username
                user {
                    username
                    email
                    name
                    status
                    created
                }
                usageType
                value
                action
                recordId
                created
           }
           nextToken
       }
   }
`;

export const getUsageRecord = `
   query getUsageRecord($id:ID!) {
       getUsageRecord(id:$id) {
                id
                username
                user {
                    username
                    email
                    name
                    status
                    created
                }
                usageType
                value
                action
                recordId
                created
       } 
}`;
